module.exports = __webpack_public_path__ + "static/img/todomath_main_feature_mode_cn.9055419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_feature_mode_cn.png
// module id = zh2/
// module chunks = 18